var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.header.classes},[_c('v-icon',{domProps:{"textContent":_vm._s(_vm.value || _vm.header.defaultValue)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }